export default __webpack_public_path__ + "static/media/halftone_joel.c98b8d1d.png";